import { FontFamily, snapFooterCss, snapHeaderCss } from '@snapchat/snap-design-system-marketing';

import type { BrandPropOverrides, SiteConfiguration } from '../../configTypes';
import { CustomLocaleDropdownButton } from './CustomLocaleDropdownButton/CustomLocaleDropdownButton';

/**
 * Shared theme configuration for Snap branded sites. This is used to maintain consistency across
 * all Snap branded sites.
 */
export const snapSiteConfigTheme: SiteConfiguration['theme'] = {
  defaultCarouselOverflowDecoration: true,
  footerPropsOverride: {
    customLocaleDropdownButton: CustomLocaleDropdownButton,
    className: snapFooterCss,
  },
  fontSettings: [
    {
      name: FontFamily.INTER,
      stylesheet: 'https://web-platform.snap.com/fonts/font.inter.css',
      files: [
        {
          url: 'https://web-platform.snap.com/fonts/inter/Inter.woff2',
          type: 'font/woff2',
        },
      ],
    },
  ],
  globalNavProps: {
    defaultGroupKey: 'snap',
    addBottomBorder: true,
    lessMargins: true,
    headerClassName: snapHeaderCss,
  },
};

/**
 * This is a helper object that can be used in site configs to have alternate brand overrides. Used
 * in sandboxConfig to help preview in both configs.
 */
export const snapBrandConfigSharedSettings: BrandPropOverrides = {
  carousel: {
    defaultCarouselOverflowDecoration: snapSiteConfigTheme.defaultCarouselOverflowDecoration,
  },
  header: snapSiteConfigTheme.globalNavProps,
  footer: snapSiteConfigTheme.footerPropsOverride,
};
